import { render, staticRenderFns } from "./SpcBrasilPJ.vue?vue&type=template&id=01f863c2"
import script from "./SpcBrasilPJ.vue?vue&type=script&lang=js"
export * from "./SpcBrasilPJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports